module.exports = __webpack_public_path__ + "static/media/WhatColorIsFire.32287b58.jpg";